import { fetchPostJsonIfValid, fetchPostValidated } from "../../utils/fetch-json.js";
import { createFormData } from "../../utils/formdata.js";

export const CommentService = {
  postComment: (uploaderId: string, recordId: string, comment: string) => {
    const url = `/v1/r/${recordId}/postComment`;
    const fd = createFormData({ comment, uploaderId });
    return fetchPostJsonIfValid(url, fd);
  },

  deleteComment: (recordId: string, createdAt: number) => {
    const url = `/v1/r/${recordId}/markDeleted?createdAt=${createdAt}`;
    return fetchPostValidated(url);
  }
};
